<template>
  <div id="hrms15e-detail1">
    <div v-show="detail1Disp">
      <div v-if="!detailDisabled" >
        <div v-if="parseInt(detail.table.rows.length) > 0">
          <div class="detail detail-responsive">
            <form class="form-horizontal ">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['90'] }}</label>
                <div class="col-md-6 ">
                  <div class="form-control readonly-field-color">{{detail.detail.codform}} - {{detail.detail.desform}}</div>
                </div>
              </div>
            </form>

            <div class="col-md-12 clear-padding margin-b-5" >
              <div class="subtract-wrapper clearfix">
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C10'] }} :</div>
                  <div class="subtract-point">{{detail.detail.v_qtydabs}} {{ labelsHrms15e['C40'] }}</div>
                </div>
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C20'] }} :</div>
                  <div class="subtract-point">{{detail.detail.v_qtydleav}} {{ labelsHrms15e['C40'] }}</div>
                </div>
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C30'] }} :</div>
                  <div class="subtract-point">{{detail.detail.v_qtydpuns}} {{ labelsHrms15e['C40'] }}</div>
                </div>
              </div>
            </div>

            <div class="col-md-12 clear-padding">
              <div class="evaluation-wrapper">
                <template v-for="dataGroup in detail.table.rows">
                  <group  :labels="labels"
                          :dropdowns="dropdowns"
                          :nowLang="nowLang"
                          :dataGroup="dataGroup"
                          name="detail1"
                          :qtydabs="detail.detail.v_qtydabs"
                          :qtydleav="detail.detail.v_qtydleav"
                          :qtydpuns="detail.detail.v_qtydpuns"
                          :flgdedbeh="indexSelected.flgdedbeh"
                          :labelsHrms15e="labelsHrms15e" />
                </template>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5">
              <div class="evaluation-sum">
                {{ labels['HRAP31EC3']['190'] }} {{ calResultScore(detail.table.rows) }}/{{ calTotalScore(detail.table.rows) }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC3']['210'] }}</label>
                <textarea class="form-control"
                          v-model="detail.detail.commboss"
                          maxlength="600"
                          v-validate="'required|max:600'"
                          data-vv-name="commboss"
                          :has-error="errors.has('commboss')" ></textarea>
                <div class="text-error" v-show="errors.has('commboss')">{{errors.first('commboss')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC3']['220'] }}</label>
                <textarea class="form-control"
                          v-model="detail.detail.commemp"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commemp"
                          :has-error="errors.has('commemp')" ></textarea>
                <div class="text-error" v-show="errors.has('commemp')">{{errors.first('commemp')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-color-skin"  @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
            </div>
            <div class="col-md-6 clear-padding">
              <div class="dropup" align="right" >
                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ labels['HRAP31EC3']['320'] }}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu2">
                  <li class="cursor-pointer"><a @click="courseRequired()">{{ labels['HRAP31EC3']['330'] }}</a></li>
                  <li class="cursor-pointer" v-if="indexSelected.flgtypap === 'T'"><a @click="appraisalOthers()">{{ labels['HRAP31EC3']['230'] }}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 clear-padding margin-b-5"  v-else >
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C50'] }}</label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="detailDisabled1">
        <template v-if="!isEmpty(detailTab1Desc2Selected)">
          <div class="detail detail-responsive clearfix">
            <div class="main-topic-box">
              <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click="triggerSetDetailTab1Desc2Selected(-1)"></i>
              <div class="main-topic">{{ labels['HRAP31EC4']['30'] }} {{ detailTab1Desc2Selected.numseq }}</div>
              <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click="triggerSetDetailTab1Desc2Selected(1)"></i>
            </div>
            <form class="form-horizontal ">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC3']['90'] }}</label>
                <div class="col-md-6 ">
                  <div class="form-control readonly-field-color">{{detailTab1Desc2Selected.codform}} - {{detailTab1Desc2Selected.desform}}</div>
                </div>
              </div>
            </form>

            <div class="col-md-12 clear-padding margin-b-5" >
              <div class="subtract-wrapper clearfix">
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C10'] }} :</div>
                  <div class="subtract-point">{{detailTab1Desc2Selected.v_qtydabs}} {{ labelsHrms15e['C40'] }}</div>
                </div>
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C20'] }} :</div>
                  <div class="subtract-point">{{detailTab1Desc2Selected.v_qtydleav}} {{ labelsHrms15e['C40'] }}</div>
                </div>
                <div class="col-md-4 subtract-box">
                  <div class="subtract-title">{{ labelsHrms15e['C30'] }} :</div>
                  <div class="subtract-point">{{detailTab1Desc2Selected.v_qtydpuns}} {{ labelsHrms15e['C40'] }}</div>
                </div>
              </div>
            </div>

            <template v-if="detailTab1Desc2Selected.table">
              <div class="col-md-12 clear-padding">
                <div class="evaluation-wrapper">
                  <template v-for="dataGroup in detailTab1Desc2Selected.table">
                    <group  :disabled="detailDisabled1"
                            :labels="labels"
                            :dropdowns="dropdowns"
                            :nowLang="nowLang"
                            :dataGroup="dataGroup"
                            name="detail1"
                            :qtydabs="detailTab1Desc2Selected.v_qtydabs"
                            :qtydleav="detailTab1Desc2Selected.v_qtydleav"
                            :qtydpuns="detailTab1Desc2Selected.v_qtydpuns"
                            :flgdedbeh="indexSelected.flgdedbeh"
                            :labelsHrms15e="labelsHrms15e" />
                  </template>
                </div>
              </div>
              <div class="col-md-12 clear-padding margin-b-5">
                <div class="evaluation-sum">
                  {{ labels['HRAP31EC3']['190'] }} {{ calResultScore(detailTab1Desc2Selected.table) }}/{{ calTotalScore(detailTab1Desc2Selected.table) }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="evaluation-sum mgb-10 ">
                <div class="form-group ">
                  <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C60'] }}</label>
                </div>
              </div>
            </template>

            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC3']['210'] }}</label>
                <textarea class="form-control"
                          v-model="detailTab1Desc2Selected.commboss"
                          :disabled="detailDisabled1"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commboss"
                          :has-error="errors.has('commboss')"></textarea>
                <div class="text-error" v-show="errors.has('commboss')">{{errors.first('commboss')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC3']['220'] }}</label>
                <textarea class="form-control"
                          v-model="detailTab1Desc2Selected.commemp"
                          :disabled="detailDisabled1"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commemp"
                          :has-error="errors.has('commemp')"></textarea>
                <div class="text-error" v-show="errors.has('commemp')">{{errors.first('commemp')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }} {{ labels['HRAP31EC3']['230'] }}</label>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-show="detail1Desc1Disp">
      <detail1Desc1   :labels="labels"
                      :searchIndex="searchIndex"
                      :indexSelected="indexSelected"
                      :detail="detailCourse"
                      :detail1Desc1Table="detail1Desc1Table"
                      :nowLang="nowLang"
                      :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                      :postDetailCourseSave="postDetailCourseSave"
                      :validateStaappr="validateStaappr" />

    </div>
  </div>
</template>

<script>
import group from 'components/hrms15e/group1'
import detail1Desc1 from 'components/hrms15e/detail1Desc1'
import _ from 'lodash'
import { constLabels } from 'assets/js/constLabels.js'
import swal from 'sweetalert'

export default {
  name: 'hrms15e-detail1',
  props: [
    'labelsHrms15e',
    'detailDisabled',
    'setDetailDisabled',
    'detailDisabled1',
    'setDetailDisabled1',
    'labels',
    'labelsButton',
    'dropdowns',
    'nowLang',
    'detail',
    'detailAll',
    'detailCourse',
    'toggle',
    'indexSelected',
    'searchIndex',
    'detail1Desc1Table',
    'receivedHrms15eDetailCourse',
    'receivedHrms15eDetailCourseAddInline',
    'receivedHrms15eDetail1Desc2',
    'postDetailCourseSave',
    'postDetail1Save',
    'detailTab1Desc2',
    'detailTab1Desc2Selected',
    'setDetailTab1Desc2Selected',
    'showDetailDescDisp',
    'setShowDetailDescDisp',
    'detail1Disp',
    'detail1Desc1Disp',
    'detail1Disp',
    'setDetail1Disp',
    'detail1Desc1Disp',
    'setDetail1Desc1Disp',
    'detailTab1Desc2IndexSelected',
    'setDetailTab1Desc2IndexSelected',
    'validateStaappr',
    'labelsHrms15e',
    'checkCompleteAll',
    'calResultScore',
    'calTotalScore'
  ],
  data () {
    return {
      detailIndex: 0,
      v_qtydabs: '1',
      v_qtydleav: '2',
      v_qtydpuns: '3'
    }
  },
  watch: {
    detailTab1Desc2IndexSelected () {
      this.detailIndex = this.detailTab1Desc2IndexSelected
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    isEmpty (detailTab1Desc2Selected) {
      return _.isEmpty(detailTab1Desc2Selected)
    },
    courseRequired () {
      let courseParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setShowDetailDescDisp(true)
      this.setDetail1Disp(false)
      this.setDetail1Desc1Disp(true)
      this.receivedHrms15eDetailCourse(courseParams)
    },
    appraisalOthers () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codform: this.detail.detail.codform,
        p_codempid_query: this.indexSelected.codempid,
        p_codaplvl: this.indexSelected.codaplvl
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetailDisabled1(true)
      this.receivedHrms15eDetail1Desc2(detailParams)
    },
    triggerSetDetailTab1Desc2Selected (index) {
      this.detailIndex += index
      if (this.detailIndex < 0) {
        this.detailIndex = this.detailTab1Desc2.rows.length - 1
      }
      if (this.detailIndex > this.detailTab1Desc2.rows.length - 1) {
        this.detailIndex = 0
      }
      this.setDetailTab1Desc2IndexSelected(this.detailIndex)
      this.setDetailTab1Desc2Selected(this.detailTab1Desc2.rows[this.detailIndex])
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let _this = this
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              // Check that every assessment is complete
              let flgComplete = _this.checkCompleteAll(_this.detail.table.rows)
              if (!flgComplete) {
                swal({
                  title: constLabels('confirmTitle'),
                  text: _this.labelsHrms15e['C100'],
                  html: true,
                  showCancelButton: true,
                  closeOnConfirm: false,
                  confirmButtonText: constLabels('ok'),
                  cancelButtonText: constLabels('cancel')
                },
                function (isConfirm2) {
                  if (isConfirm2) {
                    _this.processSave()
                  }
                })
              } else {
                _this.processSave()
              }
            }
          })
        }
      })
    },
    processSave () {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      this.saveDetail1()
    },
    saveDetail1 (saveFromStatus) {
      let calQtyCmp = this.calResultScore(this.detailAll.tab2.table.rows) * 100 / this.calTotalScore(this.detailAll.tab2.table.rows)
      if (saveFromStatus) {
        this.detail.detail.qtycmp = isNaN(calQtyCmp) ? 0 : calQtyCmp
      } else {
        this.detail.detail.qtycmp = this.indexSelected.qtycmp
      }
      this.postDetail1Save({
        indexSelected: this.indexSelected,
        searchIndex: this.searchIndex,
        detail: this.detail.detail,
        table: this.detail.table
      })
    }
  },
  components: {
    group,
    detail1Desc1
  }
}
</script>




// WEBPACK FOOTER //
// detail1.vue?5200bd6c